import React from "react";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import GlobalCta from "../../components/global/GlobalCta";
import PageHero from "../../components/global/PageHero";
import ServiceOverview from "../../components/global/ServiceOverview";
import ServiceFeatures from "../../components/global/ServiceFeatures";
import ServiceChecks from "../../components/global/ServiceChecks";

const OVERVIEW = [
    "WooCommerce is one of the most popular commerce plugins in the world — an easy-to-use, open-source way to build and run a store on WordPress. We take it beyond the defaults with real customisation.",
    "From store setup to bespoke plugins and payment integrations, we build WooCommerce stores that fit your catalogue, your checkout and your growth plans.",
];

const FEATURES = [
    { title: "Store development", text: "A complete WooCommerce build shaped around your products and workflow." },
    { title: "Custom plugin development", text: "Bespoke features added the right way, so updates stay safe." },
    { title: "Payment gateway integration", text: "The gateways your customers expect, wired in and tested." },
    { title: "API integration", text: "Connect WooCommerce to the tools that run the rest of your business." },
];

const CHECKS = [
    "WooCommerce store development",
    "Plugin development",
    "WooCommerce customisation",
    "Payment gateway development",
    "WooCommerce API integration",
];

export default function WoocommerceDevelopment() {
    return (
        <>
            <Header />

            <main>
                <PageHero eyebrow="E-Commerce" title="WooCommerce Customisation" eyebrowAs="span">
                    Flexible, scalable WooCommerce stores built on WordPress — easy to run, tuned to sell.
                </PageHero>
                <ServiceOverview paragraphs={OVERVIEW} />
                <ServiceFeatures items={FEATURES} />
                <ServiceChecks title="What's included" items={CHECKS} />
            </main>

            <GlobalCta />

            <Footer />
        </>
    );
}
